import React from 'react';

function Loader({ size = 'medium', color = '#1976d2' }) {
  const getSizeStyles = () => {
    switch (size) {
      case 'small':
        return {
          width: '20px',
          height: '20px',
          borderWidth: '2px'
        };
      case 'large':
        return {
          width: '60px',
          height: '60px',
          borderWidth: '6px'
        };
      default: // medium
        return {
          width: '40px',
          height: '40px',
          borderWidth: '4px'
        };
    }
  };

  const sizeStyles = getSizeStyles();

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px',
      width: '100%'
    }}>
      <div
        style={{
          ...sizeStyles,
          border: `${sizeStyles.borderWidth} solid #f3f3f3`,
          borderTop: `${sizeStyles.borderWidth} solid ${color}`,
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}
      />
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}

export default Loader;
